export var ResourceBlockerGroup;
(function (ResourceBlockerGroup) {
    ResourceBlockerGroup["RESOURCE_BLOCKER_GROUP_BACKUP_UNSUPPORTED"] = "BLOCKER_GROUP_BACKUP_UNSUPPORTED";
    ResourceBlockerGroup["RESOURCE_BLOCKER_GROUP_ACTION_REQUIRED"] = "BLOCKER_GROUP_ACTION_REQUIRED";
    ResourceBlockerGroup["RESOURCE_BLOCKER_GROUP_CLASSIFICATION_FAILED"] = "BLOCKER_GROUP_CLASSIFICATION_FAILED";
})(ResourceBlockerGroup || (ResourceBlockerGroup = {}));
